const FormsUX = () => {
    if ($('form').length <= 0) return null;

    $('input').each(function() {
        if ($(this).val() !== '') {
            $(this).addClass('has-value');
        }
    })

    $('input').change(function() {
        if($(this).val() !== '') {
            $(this).addClass('has-value');
        } else {
            $(this).removeClass('has-value');
        }
    })
}

export default FormsUX;